import type {
  BoggleBadgeCategory,
  BoggleBadgeLevel,
  BoggleBadgeLockedReveal,
} from './types'

/** Authored tiered badge families (one Compendium tile per tier). */
export type BoggleBadgeFamilyId =
  | 'abecedarian'
  | 'anadrome'
  | 'battery'
  | 'cartographer'
  | 'clutch'
  | 'frenzy'
  | 'generalist'
  | 'greedy'
  | 'juggernaut'
  | 'lexicographer'
  | 'machine'
  | 'pangrammatist'
  | 'pizazz'
  | 'prospector'
  | 'quickdraw'
  | 'sesquipedalian'
  | 'steady'
  | 'versatile'

export const BOGGLE_TIER_ROMAN = ['I', 'II', 'III', 'IV'] as const

export type BoggleTieredFamilyTierConfig = {
  /** When set, used instead of formatting `descriptionTemplate`. */
  descriptionOverride?: string
  level: BoggleBadgeLevel
  /** 1-based tier index within the family. */
  tierIndex: number
}

export type BoggleTieredFamilyConfig = {
  category: BoggleBadgeCategory
  /**
   * Description template with bracket groups listing all tier values, e.g.
   * `Play [3 / 4 / 5] words in [3] seconds`. Each group is resolved to the
   * value at the viewed tier index when formatting.
   */
  descriptionTemplate: string
  familyId: BoggleBadgeFamilyId
  iconId: string
  lockedReveal: BoggleBadgeLockedReveal
  name: string
  tiers: readonly BoggleTieredFamilyTierConfig[]
}
